import { Button, Tooltip } from "@fluentui/react-components";
import styled, { css, CSSProperties } from "styled-components";

import { devices } from "../../library/constants";

export const Flex = styled.div<{
  $gap?: CSSProperties["gap"];
  direction?: "row" | "column";
  $justify?: "center" | "flex-end" | "flex-start" | "space-between" | "space-around";
  align?: "center" | "flex-end" | "flex-start" | "normal" | "baseline";
  wrap?: "nowrap" | "wrap";
  width?: CSSProperties["width"];
}>`
  display: flex;
  align-items: ${(p) => p?.align || "center"};
  gap: ${(p) => p.$gap || "5px"};
  width: ${(p) => p.width || "auto"};
  flex-direction: ${(p) => p.direction || "row"};
  justify-content: ${(p) => p.$justify || "flex-start"};
  flex-wrap: ${(p) => p.wrap || "wrap"};
  box-sizing: border-box;
`;

export const StyledErrorMessage = styled.span`
  color: ${({ theme }) => theme.semanticColors.errorText};
  font-size: 12;
`;

export const ErrorMessageContainer = styled.span`
  height: 20px;
`;

export const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2px;
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const PageContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 10px 10px 0;
  margin: 5px auto 0;
  height: 100%;
  box-sizing: border-box;
  gap: 0px;
  @media only screen and ${devices.md} {
    justify-content: flex-start;
    padding: 10px 20px;
    width: 100%;
  }
`;

export const ActionButton = styled(Button)<{ noBorder?: boolean }>`
  ${({ disabled, noBorder, theme }) =>
    !disabled &&
    css`
      display: flex;
      align-items: center;

      max-width: fit-content;
      border: 1px solid ${() => (noBorder ? "transparent" : theme.palette.purpleDark)};
      color: ${(props) => props.theme.palette.purpleDark};
      background: transparent;
      height: fit-content;
    `}
`;

export const RemoveButton = styled(Button)`
  ${({ disabled }) =>
    !disabled &&
    css`
      display: flex !important;
      align-items: center;

      max-width: fit-content;
      border: 1px solid ${({ theme }) => theme.palette.redDark} !important;
      color: ${(props) => props.theme.palette.redDark} !important;
      background: transparent;
      height: fit-content;
      &:hover {
        opacity: 0.7;
        background: ${({ theme }) => theme.palette.redDark} !important;
        color: ${(props) => props.theme.palette.white} !important;
      }
    `}
`;

export const Grid = styled.div<{ gridColumns?: number }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0px;
  @media only screen and ${devices.md} {
    grid-template-columns: ${({ gridColumns }) => `repeat(${gridColumns || 3}, 1fr)`};
    gap: 15px;
  }
`;

export const StyledTooltip = styled(Tooltip)`
  font-size: 14px;
  line-height: 20px;
  width: 300px;
  max-width: 300px;
`;

export const CardListWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  box-sizing: border-box;
  gap: 20px;
  width: 100%;

  @media only screen and ${devices.md} {
    grid-template-columns: repeat(2, 1fr);

    flex-direction: row;

    justify-content: flex-start;
    gap: 20px;
  }
`;

export const StyledButton = styled(Button)`
  span {
    font-size: 23px;
    width: 23px;
    height: 23px;
  }
  &:disabled {
    background: ${({ theme }) => theme.palette.neutralLight};
  }
`;

export const ProfileContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto 30px;
`;

export const GrowBtnSmall = styled(Button)`
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.01);
  }
`;
